<template>
  <div class="d-flex justify-space-around">
    <div
      v-for="i in [0, 1, 2, 3]"
      :key="`indicator${i}`"
      class="indicator-light"
      :class="{'valid': state >= i}"
    />
  </div>
</template>

<script>
export default {
  name: 'ScanProgress',

  props: {
    state: { type: Number, default: 0 }
  }
}
</script>

<style scoped>
.indicator-light {
  width: 70px;
  height: 35px;
  border: 2px solid black;
  border-radius: 12px;
  background-color: #8e9090;
}
.indicator-light.valid {
  background-color: #4CAF50;
}
</style>
